import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
export default function PrevPolicyDisplay() {
  const custDetail = useSelector(
    (state) => state.vehicledetail.prevpolicydetail
  );
  // console.log("custDetail", custDetail);
  return (
    <>
      <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1 customer-card">
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Previous Insurer</div>
          <div className="indivtext">{custDetail?.prevInsurerName}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Previous Policy Number</div>
          <div className="indivtext">{custDetail?.previousPolicyNumber}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Previous Policy Expiry</div>
          <div className="indivtext">
            {moment(custDetail?.previousPolicyExpiryDate).format("YYYY-MM-DD")}
          </div>
        </div>
        {custDetail?.tpInsurerCode ?
        <>
         <div className="bundle-tp px-3 py-3 col-xl-12 col-lg-4 col-md-6 col-sm-6 col-6">TP Details</div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Previous TP Insurer</div>
          <div className="indivtext">{custDetail?.tpInsurerName}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Previous TP Policy Number</div>
          <div className="indivtext">{custDetail?.tp_policy_number}</div>
        </div>
        </>
        : null }
      </div>
    </>
  );
}
